export default "__VITE_ASSET__0ca1766d__"